<template>
  <div class="page withdraw-preview">
    <!-- 导航条 -->
    <navigation type="second-level" :sticky="true">预览申请</navigation>
    <div class="noticeBar">请确认借款信息真实及完整性，用于本次协商还款申请</div>
    <common :index="1"/>
    <!-- 预览信息 -->
    <section class="card-panel">
      <nd-cell
        class="info-line"
        :arrow="false"
        title="提现金额 (元)"
      ><span slot="text" style="color: #FF3446">{{form.applyAmt|currency}}</span></nd-cell>
      <nd-cell
        class="info-line"
        :arrow="false"
        title="分期期数"
        :text="`${form.applyTerm}期`"
      ></nd-cell>

      <nd-cell
        class="info-line"
        :arrow="false"
        title="用途"
        :text="form.purpose|filterPurpse"
      ></nd-cell>

      <nd-cell
        class="info-line shine"
        title="收款银行卡"
        :text="`${cardText}`"
        @click="goBankCard"
      ></nd-cell>

      <div class="info-other">
        <p class="other-title">其他信息</p>
        <p class="other-money">应还总息费(元)：<span>¥{{form.interestFee| currency}}</span></p>
        <p class="other-rate">综合年化利率(单利计算)：<span>{{form.intRate * 100| currency}}%</span>
          <img class="other-img" @click="handleShowTips" src="./images/icon_info@3x.png" alt="">
        </p>
      </div>
    </section>
    <div class="repayment-schedule a">
      <div class="cell-title">
        还款计划<em>（还款实际到期日以实际放款时间为准）</em>
      </div>

      <div class="schedule-list">
        <table>
          <thead>
            <tr class="table-header">
              <th width="35%">到期日</th>
              <th width="20%">期数</th>
              <th width="30%">当期应还(元)</th>
            </tr>
          </thead>
          <tbody style="padding: 31px 0;">
            <tr
              class="table-row"
              v-for="(item, index) in form.termInfo"
              :key="index"
            >
              <td>{{ item.paidOutDate | date('YYYY/MM/DD') }}</td>
              <td>{{ item.termNo }}/{{ form.termInfo.length }}</td>
              <td>{{ item.schdAmt | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- 预览申请 -->
    <section class="bottom">
      <!-- 相关协议 -->
      <nd-button
        class="withdraw-btn"
        :disabled="!selectedBankcard.hasOwnProperty('bankCardNo')"
        @click="goWithdraw"
      >立即申请</nd-button>
      <section class="read-protocol">
        <span>点击「立即提现」按钮，表示您已阅读并同意<em
          @click.stop="viewProtocol"
        >《相关协议》</em></span>
      </section>
    </section>

    <!-- 提现短信验证码 -->
    <nd-sms
      :duration="120"
      :showMobile="false"
      :tips="smsTips"
      title="短信认证"
      v-model="smsVisible"
      @retrieve="sendSmsAgain"
      @confirm="confirmWithdraw"
      @countEnd="countEnd"
      :errorTip="errorTip"
    ></nd-sms>

    <!-- 强弹征信协议 -->
    <nd-dialog v-model="authenticationVisible" class="auth-dialog" :footer="false" :closeBtn="greyShow?false:true" @close="closeBtn">
      <div class="default-content">
        <iframe ref="authIframe" @load="IframeLoaded" class="iframe" :src="authenticationProtocol" frameborder="0"></iframe>
      </div>
      <div class="btn-wrapper">
        <nd-button v-if="!greyShow" class="btn" @click="agreeAuthentication">我已完成阅读并同意上述协议</nd-button>
        <nd-button v-if="greyShow" :disabled="COUNT_DOWN > 0" class="btn" @click="agreeAuthentication">我已阅读并同意上述协议{{countdownSubfix}}</nd-button>
      </div>
    </nd-dialog>
        
    <nd-dialog
      v-model="rateTipsVisible"
      closeBtn
      :footer="false"
    >
      <div class="rate-tips-title">综合年化利率说明</div>
      <div class="rate-tips-dialog">
        <p>该笔订单1年内用户需要承担的综合费用占本金的比率，1年以12个月计算。</p>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import NdSms from '../../bankcard/components/nd-sms'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getKey } from '../../../assets/utils'
import common from './components/common'
export default {
  name: 'repayment-consult-apply',

  description: '预览申请',

  components: {
    NdSms, common
  },

  customReadyNotify: true,

  data () {
    return {
      fundCode: this.$route.query.fundCode,
      needLiveDetection: false, // 是否需要活体认证
      isPass: false, // 是否通过活体认证
      smsVisible: false, // 是否显示短信验证码弹出框
      errorTip: '', // 短信验证码后端错误提示
      selectedBankcard: {}, // 是否已有银行卡
      applySerialNo: '',
      consultWay: 'SMS', // 确认方式
      canSendSms: true,
      authenticationVisible: false,
      authenticationProtocol: '', 
      greyShow: false, // 用来展示是否是灰度 包含大兴安岭资方灰度测试（不可点击
      COUNT_DOWN: 10,
      timer: null,
      rateTipsVisible: false,
      form: {
        // 提现表单
        applyAmt: '',
        applyTerm: '',
        purpose: '',
        termInfo: [], // 还款试算
        intRate: '', // 利率
        interestFee: '', // 总息费
        originalBillBank: {}, // 借款申请预览返回的银行卡
        originalPlatBillNo: '',
        loanPlatform: 'TMD'
      }
    }
  },
  filters: {
    filterPurpse (value = {}) {
      return value.description || ''
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    countdownSubfix () {
      if (this.COUNT_DOWN > 0) {
        return ` (${this.COUNT_DOWN}S)`
      }
      return ''
    },

    ...mapState({
      dictionary: (state) => state.dictionary
    }),

    cardText () {
      if (this.selectedBankcard.bankCardNo) {
        const code = this.selectedBankcard.bankCardNo.substr(-4, 4)
        return `${this.selectedBankcard.bankName}(${code})`
      } else {
        return `选择银行卡`
      }
    },

    smsTips () {
      return `<span>您正在执行提现操作，提现验证码已发送您的手机，请查收<em>${this.formatMobile(
        this.userInfo.mobile
      )}</em></span>`
    }
  },
  async created () {
    this.dealApplyData()
    // 判断活体是否通过
    if (this.$route.query.result === 'PASS') {
      this.isPass = this.$route.query.result === 'PASS'
      this.fundCode = this.$storage.get('fundCode')
      // 查看是否可自动提现
      this.canStartAutoWithdraw()
    } else {
      await Promise.all([
        this.getUserInfoX(),
        this.getLoanParameter()
      ])
      this.getBankcardList()
    }
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('user', ['getUserInfoX']),
    ...mapActions('withdraw', [
      'getLoanParameterX'
    ]),
    ...mapActions('repay', ['consultConfirm', 'consultApply', 'consult']),
    ...mapMutations('withdraw', ['setWithdrawForm']),
    ...mapMutations('bankcard', ['setSelectedBankcard']),
    ...mapActions('bankcard', ['getBankcardListX']),
    countdown () {
      this.timer = setInterval(() => {
        if (this.COUNT_DOWN < 1) {
          clearInterval(this.timer)
        } else {
          this.COUNT_DOWN--
        }
      }, 1000)
    },
    dealApplyData () {
      const obj = JSON.parse(localStorage.getItem('consultApply') || '{}')
      this.form = { ...this.form, ...obj }
    },
    // 获取银行卡列表
    async getBankcardList () {
      const response = await this.getBankcardListX({
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        productCd: 'TMDP'
      })
      if (response.success && response.data.length > 0) {
        let obj = {}
        const bank = JSON.parse(JSON.stringify(this.$store.state.bankcard.selectedBankcard))
        const { bankCardNo } = this.form.originalBillBank || {}
        const defaltBankFilter = response.data.filter(
          (item) => item.bankCardNo === bankCardNo
        )
        if (bank.bankCardNo) {
          obj = bank
        } else {
          obj = defaltBankFilter[0] || {}
        }
        this.selectedBankcard = obj
      }
    },

    // 获取是否需要活体
    async getLoanParameter () {
      const response = await this.getLoanParameterX({
        loanPlatform: 'TMD'
      })
      if (response.success) {
        this.needLiveDetection = response.data.needLiveDetection
      } else {
        throw new Error('获取借款参数失败')
      }
    },
    // 查看相关协议
    viewProtocol () {
      this.$router.push({
        path: '/withdraw/protocol',
        query: {
          fundCode: this.$route.query.fundCode,
          busiType: 'CONSULT_LOAN'
        }
      })
    },
    // 发起活体认证
    startAuth () {
      this.$storage.set('applySerialNo', this.applySerialNo)
      this.$storage.set('consultWay', 'LIVENESS')
      this.$storage.set('faceSource', 'consult')
      this.$storage.set('fundCode', this.$route.query.fundCode)
      this.$router.replace('/authentication/face?sceneType=CONSULT_REPAYMENT')
    },
    // 短信失效或者错误 - 再次发起申请
    async sendSmsAgain (reset) {
      const response = await this.consultApplyX()
      if (response.success) {
        this.applySerialNo = response.data.applySerialNo
        this.canSendSms = false
        reset()
      } else {
        if (response.code === '000028') {
          this.applySerialNo = response.msg
          this.canSendSms = false
          reset()
        } else {
          this.$message(response.msg)
        }
      }
    },
    // 协商还款借款申请
    async consultApplyX () {
      const { applyAmt, applyTerm, purpose = {} } = this.form || {}
      const { bankCardNo } = this.selectedBankcard || {}
      let trafficCode = getKey('channel') ? { trafficCode: getKey('channel') } : {}
      const response = await this.consultApply({
        loanPlatform: this.loanPlatform,
        originalPlatBillNo: this.form.originalPlatBillNo,
        applyAmount: applyAmt,
        loanPurpose: purpose.key,
        applyTerm,
        bank: {
          bankCardNo
        },
        ...trafficCode
      })
      return response
    },

    IframeLoaded () {
      this.$nextTick(() => {
        this.$refs['authIframe'].contentWindow.postMessage({
          type: 'setFontSize',
          value: document.documentElement.style.fontSize
        }, '*')
      })
    },

    agreeAuthentication () {
      this.$report({
        id: this.greyShow ? 10175 : 10172,
        args: {
          visible: 0
        }
      })
      this.$report({
        id: this.greyShow ? 10171 : 10174,
        args: {
          visible: 0
        }
      })
      this.authenticationVisible = false
      this.goWithdraw()
    },
    closeBtn () {
      this.$report({
        id: 10173
      })
    },
    goWithdraw () {
      this.$report({
        id: 10092
      })
      this.applyWithdraw()
    },

    // 倒计时结束可再次发送验证码
    countEnd () {
      this.canSendSms = true
    },

    // 重新绑卡
    reBindBankcard () {
      this.setSelectedBankcard({})
      this.$router.push({
        path: '/bankcard/add',
        query: {
          position: 'repay',
          loanPlatform: 'TMD',
          fundCode: this.fundCode,
          productCd: 'TMDP',
          bankMobile: this.selectedBankcard.bankMobile,
          bankcardNo: this.selectedBankcard.bankCardNo,
          canChangePhoneNo: this.selectedBankcard.canChangePhoneNo
        }
      })
    },
    // 申请提现
    async applyWithdraw () {
      if (this.selectedBankcard.invalid) {
        return this.reBindBankcard()
      }
      this.errorTip = ''
      if (!this.canSendSms) {
        this.smsVisible = true
        return
      }
      // 全部完成 -> 去授信
      // await this.riskReport(3)
      const response = await this.consultApplyX()
      if (response.code === '100018') {
        this.reBindBankcard()
        return
      }
      if (response.success) {
        this.applySerialNo = response.data.applySerialNo
        if (response.data.confirmWay === 'LIVENESS') {
          return this.startAuth()
        }
        this.canSendSms = false
        this.smsVisible = true
      } else {
        if (response.code === '000028') {
          this.smsVisible = true
          this.canSendSms = false
          this.applySerialNo = response.msg
        } else {
          this.$message(response.msg)
        }
      }
    },

    // 确认提现
    async confirmWithdraw (code = '') {
      if (code) {
        this.$report({
          id: 10094
        })
      }
      const response = await this.consultConfirm({
        applySerialNo: this.applySerialNo,
        smsCode: code,
        confirmWay: this.consultWay
      })
      if (response.success) {
        this.$report({
          id: 10112,
          args: {
            succeed: 1
          }
        })
        this.$storage.remove('fundCode')
        this.$router.replace(
          `/repayment/consult/result?applySerialNo=${response.data.applySerialNo}`
        )
      } else {
        if (response.code === '000010') {
          this.errorTip = response.msg
          this.$report({
            id: 10112,
            args: {
              succeed: 0
            }
          })
        }
        if (response.code === '100007') {
          this.errorTip = response.msg
        }
      }
    },

    // 是否可以发起自动提现 - 活体认证返回
    canStartAutoWithdraw () {
      if (this.isPass) {
        this.applySerialNo = this.$storage.get('applySerialNo')
        this.consultWay = this.$storage.get('consultWay')
        this.confirmWithdraw()
      }
    },

    // 去绑卡
    goBankCard () {
      this.$router.push({
        path: '/bankcard/list',
        query: {
          position: 'repay',
          loanPlatform: 'TMD',
          fundCode: this.fundCode,
          productCd: 'TMDP'
        }
      })
    },
    // 显示年化利率的弹窗
    handleShowTips () {
      this.rateTipsVisible = true
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  watch: {
    smsVisible (value) {
      if (value) {
        this.$report({
          id: 10093,
          args: {
            visible: 1
          }
        })
      } else {
        this.$report({
          id: 10093,
          args: {
            visible: 0
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

@keyframes shine {
    0% {
        background-color: #ffddd9;
    }
    20% {
        background-color: #ffffff;
    }
    40% {
        background-color: #ffddd9;
    }
    60% {
        background-color: #ffffff;
    }
    80% {
        background-color: #ffddd9;
    }
    100% {
        background-color: #ffffff;
    }
}
.through{
    text-decoration: line-through;
    padding-right:15px;
}
.noticeBar{
    width: 750px;
    height: 70px;
    background: #FFF9F1;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF8864;
    line-height: 33px;
    display:flex;
    align-items: center;
    justify-content:center;
}
.withdraw-preview {
    padding-bottom: 325px;
    min-height: 100%;
    box-sizing: border-box;
    background-color: RGBA(250, 250, 250, 1);

    .card-panel {
        margin-top: 20px;

        .info-line {
            height: 100px;
            line-height: 100px;
            border-bottom: 1px solid #eee;
            position: relative;
            margin-bottom: 1px;
            font-size: 30px;
            color: rgba(51, 51, 51, 1) !important;
            &:last-child {
                animation: shine 2000ms step-end;
            }

            .custom-icon {
                display: block;
                width: 30px;
                height: 30px;
                background-size: 100%;
                float: right;
                position: relative;
                top: 35px;
                margin-left: 10px;
            }

            .weight {
                font-size: 34px;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: #20c7c7;
            }
        }
        .info-other{
            width: 100%;
            background-color: #fff;
            margin-top: 21px;
            padding: 28px 30px;
            .other-title{
                color: #333333;
                font-size: 30px;
            }
            .other-money{
                color: #999999;
                font-size: 26px;
                margin-top: 15px;
            }
            .other-rate{
                color: #999999;
                font-size: 26px;
                margin-top: 10px;
                .other-img{
                    width: 26px;
                    height: 26px;
                    vertical-align: -3px;
                }
            }
        }
    }
    .repayment-schedule {
        margin: 40px 30px 0;
        border-radius: 10px;
        &.b {
            background-color: #fff;
            .cell-title {
                padding: 33px 40px;
                .show-detail {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    color: rgba(142, 178, 216, 1);
                    line-height: 50px;
                    > img {
                        width: 29px;
                        height: 29px;
                        margin-left: 8px;
                        transition: all .3s;
                    }
                }
            }
        }
        .cell-title {
            font-size: 32px;
            line-height: 50px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;

            em {
                font-size: 26px;
                font-style: normal;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: @fc3;
            }
        }

        .schedule-list {
            margin-top: 22px;
            padding-bottom: 20px;
            background-color: #ffffff;
            border-radius: 10px;
            table {
                width: 100%;
                border-spacing: 0px;

                .table-header {
                    th {
                        font-size: 27px;
                        height: 50px;
                        line-height: 50px;
                        padding-top: 23px;
                        padding-bottom: 7px;
                        border-bottom: 1px solid @iuc;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                    }
                }

                .table-row {
                    td {
                        height: 50px;
                        line-height: 50px;
                        font-size: 22px;
                        padding-top: 10px;
                        text-align: center;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                    }

                    & + .table-row {
                        td {
                            padding-top: 2px;
                        }
                    }
                }
            }
        }
    }

    > .bottom {
        width: 750px;
        height: 230px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.04);
        position: fixed;
        bottom: 0;
        .read-protocol {
            width: 100%;
            text-align: center;
            margin-top: 25px;
            span {
                font-family: 'PingFangSC-Regular';
                font-weight: 400;
                color: #666;
                font-size: 24px;
                line-height: 33px;
                em {
                    font-style: normal;
                    color: rgba(142, 178, 216, 1);
                    margin-left: 5px;
                    margin-right: 5px;
                }
            }
        }
        .withdraw-btn {
            width: 650px;
            height: 94px;
            border-radius: 47px;
            margin: 30px auto 0;
        }
    }

    .auth-dialog {
        .default-content {
            width: 620px;
            border-radius: 30px 30px 0 0;
            padding-top: 40px;
            background: white;
            height: 638px;
            overflow: auto;
            .dialog-title {
                text-align: center;
                font-size: 36px;
                padding-bottom: 15px;
                font-weight: 600;
            }

            .dialog-footer {
                padding: 0 50px;
                padding-bottom: 40px;
                display: flex;
                justify-content: space-between;
                background-color: #FFFFFF;

                .btn {
                    width: 240px;
                    height: 80px;
                    line-height: 80px;
                }
            }
        }
        .iframe {
            height: 638px;
            width: 100%;

            html {
                width: 100%;
            }
        }

        .btn-wrapper {
            position: fixed;
            background: white;
            height: 162px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width:620px;
            border-radius:  0 0 30px 30px;
            transform: translateY(-20px);
            .btn {
                width: 500px;
            }
        }
    }
    /deep/ .rate-tips-title{
        font-size: 42px;
        color: #333333;
        font-weight: bold;
        padding-left: 40px;
    }
    .rate-tips-dialog{
        padding: 40px 40px 60px;
        color: #666666;
        font-size: 28px;
    }
}
</style>
